import { STORES, idbClear, idbDelete, idbGet, idbGetAllKeys, idbPut } from "./db"

// Mirrors the store for this session so a device without IndexedDB can still browse.
const memorySnapshots = new Map()

// Bumped by a clear so a download that was already in flight cannot write data back.
let generation = 0
let hasRequestedPersistence = false

export function snapshotKey(restaurantId, language) {
  return `${restaurantId}|${language}`
}

export function currentGeneration() {
  return generation
}

export async function readSnapshotRecord(key) {
  return memorySnapshots.get(key) ?? (await idbGet(STORES.SNAPSHOTS, key))
}

// One put replaces the previous copy atomically; false means it only lives in memory.
export async function writeSnapshotRecord(record, expectedGeneration) {
  if (expectedGeneration !== generation) return false
  memorySnapshots.set(record.key, record)
  const isSaved = (await idbPut(STORES.SNAPSHOTS, record, record.key)) !== null
  if (isSaved) requestPersistentStorage()
  return isSaved
}

// Keeps only the copy for the restaurant and language in use.
export async function pruneSnapshotRecords(keepKey) {
  for (const key of [...memorySnapshots.keys()]) {
    if (key !== keepKey) memorySnapshots.delete(key)
  }
  const keys = await idbGetAllKeys(STORES.SNAPSHOTS)
  await Promise.all(keys.filter((key) => key !== keepKey).map((key) => idbDelete(STORES.SNAPSHOTS, key)))
}

export async function clearSnapshotRecords() {
  generation += 1
  memorySnapshots.clear()
  await idbClear(STORES.SNAPSHOTS)
}

// Asks the browser not to evict the menu under storage pressure; best effort.
function requestPersistentStorage() {
  if (hasRequestedPersistence) return
  hasRequestedPersistence = true
  navigator.storage?.persist?.().catch(() => {})
}
